const truncateWithEllipses = (text, max = 50) => {
    return text.substr(0,max - 1) + (text.length > max ? '...' : '');
};


export default truncateWithEllipses;